import * as React from 'react';

import { Link } from '../Link';

interface ILegalDocumentsCommonProps {
  onLinkClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const LegalDocumentsCommon: React.FC<ILegalDocumentsCommonProps> = ({ onLinkClick }) => (
  <>
    ЦИАН — база данных о недвижимости. Использование сайта означает согласие с{' '}
    <Link href="/legal-documents/pravila_polzovaniya_sajtom_cian_0/" theme="accent" onClick={onLinkClick}>
      Пользовательским соглашением
    </Link>{' '}
    и{' '}
    <Link href="/legal-documents/politika_konfidencialnosti_0/" theme="accent" onClick={onLinkClick}>
      Политикой конфиденциальности ЦИАН
    </Link>
    . Оплачивая лицензионный платеж, вы принимаете{' '}
    <Link href="/legal-documents/licenzionnoe_soglashenie_0/" theme="accent" onClick={onLinkClick}>
      Лицензионное соглашение
    </Link>
    .
  </>
);
